import * as React from 'react';

export default () => {
    return <h1>welcome page</h1>
}